import { SigninComponent } from './pages/signin/signin.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { RecoverPasswordComponent } from './pages/recover-password/recover-password.component';

const routes: Routes = [
  { path: '', title: 'Login', component: SigninComponent },
  { path: 'esqueceu-senha', title: 'Recuperar Senha', component: RecoverPasswordComponent },
  { path: 'esqueceu-senha/alterar/:id', title: 'Alterar Senha', component: ResetPasswordComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
